import HomePage from "./HomePage";
import TutorialPage from "./TutorialPage";

export const routes = [
  {
    path: "/",
    component: HomePage,
  },
  {
    path: "/tutorial",
    component: TutorialPage,
  },
];
